module.exports = __webpack_public_path__ + "img/d- (16).8417c413.png";